module.exports = "<div class=\"py-2\">\r\n  <cco-spinner name=\"claimPartiesSpinner\"></cco-spinner>\r\n  <cco-grid #ccogrid [dataSource]=\"gridData\" [columns]=\"displayColumns\"></cco-grid>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-parties/claim-parties.component.html
// module id = ../../../../../src/app/claim/claim-parties/claim-parties.component.html
// module chunks = main